// KK Category Product Slider JS
function initCategorySlider() {
  $('.category-slider').each(function () {
    var $section = $(this);
    var $owl = $section.find('.categories-owl');

    if (!$owl.length) return;

    if ($owl.hasClass('owl-loaded')) return;

    var totalSlides = $owl.find('.item').length;

    if (totalSlides <= 3) {
      $owl.addClass('no-carousel');
      return;
    }

    $owl.owlCarousel({
      loop: true,
      margin: 30,
      nav: false,
      dots: false,
      smartSpeed: 600,
      responsive: {
        0: { items: 1 },
        480: { items: 2 },
        768: { items: 3 },
        1024: { items: 3 }
      }
    });

    $section.find('.owl-next').click(function () {
      $owl.trigger('next.owl.carousel');
    });

    $section.find('.owl-prev').click(function () {
      $owl.trigger('prev.owl.carousel');
    });
  });
}

$(document).ready(initCategorySlider);
$(document).on('shopify:section:load', initCategorySlider);

// Ingredient Slider
document.addEventListener('DOMContentLoaded', function () {
    var owl = $('.ingredient-slider');
    owl.owlCarousel({
      loop: true,
      margin: 20,
      nav: false,
      dots: false,
      responsive: {
        0: { items: 1 },
        480: { items: 2 },
        768: { items: 3 },
        1024: { items: 6 },
      },
    });
    document.querySelector('.next').addEventListener('click', function () {
      owl.trigger('next.owl.carousel');
    });
    document.querySelector('.prev').addEventListener('click', function () {
      owl.trigger('prev.owl.carousel');
    });
  });

//  KK Expert Review Section JS
document.addEventListener('DOMContentLoaded', function () {
    $('.expert-carousel').owlCarousel({
      loop: true,
      margin: 20,
      center: true,
      dots: true,
      items: 1,
      stagePadding: 150,
      responsive: {
        0: { stagePadding: 40 },
        768: { stagePadding: 150 },
        1000: { stagePadding: 350 },
        1500: { stagePadding: 550 },
      },
    });

  function getYoutubeEmbedUrl(url) {
  if (!url) return '';

  let videoId = '';

  if (isYouTubeShorts(url)) {
    videoId = getShortsVideoId(url);
  } else {
    videoId = getRegularVideoId(url);
  }

  if (!videoId) return '';

  return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0&enablejsapi=1`;
}

  function isYouTubeShorts(url) {
    try {
      const u = new URL(url);
      return u.pathname.includes('/shorts/');
    } catch (e) {
      return false;
    }
  }

function getShortsVideoId(url) {
  try {
    const u = new URL(url);
    return u.pathname.split('/shorts/')[1]?.split('?')[0] || '';
  } catch (e) {
    return '';
  }
}

function getRegularVideoId(url) {
  try {
    const u = new URL(url);

    // youtu.be/VIDEO_ID
    if (u.hostname.includes('youtu.be')) {
      return u.pathname.replace('/', '');
    }

    // youtube.com/embed/VIDEO_ID
    if (u.pathname.includes('/embed/')) {
      return u.pathname.split('/embed/')[1];
    }

    // youtube.com/watch?v=VIDEO_ID
    if (u.searchParams.get('v')) {
      return u.searchParams.get('v');
    }

    return '';
  } catch (e) {
    return '';
  }
}

    $("body").on("click", ".play-btn", function () {

        var video = $(this).attr("data-video");
        var videoType = $(this).attr("data-video-type");

        // RESET
        $("#videoFrame").hide().attr("src", "");
        $("#uploadedVideo").hide().attr("src", "");

        // YOUTUBE VIDEO
        if (videoType == "youtube") {

            $("#videoFrame")
                .attr("src", getYoutubeEmbedUrl(video))
                .show();

        }

        // SHOPIFY UPLOADED VIDEO
        else if (videoType == "upload") {

            $("#uploadedVideo")
                .attr("src", video)
                .show()[0]
                .play();

        }

        $(".video-modal").fadeIn();
    });


    

    $('.close-btn, .video-modal').click(function (e) {
        if (e.target !== this) return;

        $('.video-modal').fadeOut();

        // Stop YouTube iframe
        $('#videoFrame').attr('src', '');

        // Stop uploaded video
        $('#uploadedVideo')[0].pause();
        $('#uploadedVideo').attr('src', '');

    });
  });

  //KK Article Section
  $(document).ready(function () {
    var owl = $('.hair-carousel');

    owl.owlCarousel({
      loop: true,
      margin: 20,
      nav: false,
      dots: false,
      responsive: {
        0: { items: 1 },
        768: { items: 2 },
        1200: { items: 2.5 },
      },
    });

  function updateEvenCards() {
      $('.hair-carousel .owl-item:not(.cloned) .card').each(function (index) {
        $(this).toggleClass('reverse', index % 2 === 1);
      });
    }
    owl.on('initialized.owl.carousel translated.owl.carousel', function () {
      updateEvenCards();
    });
    setTimeout(updateEvenCards, 100);
    $('.next-btn').click(function () {
      owl.trigger('next.owl.carousel');
    });
    $('.prev-btn').click(function () {
      owl.trigger('prev.owl.carousel');
    });
  });

 window.addEventListener("scroll", function () {
  const images = document.querySelectorAll(".parallax");
  let scrollY = window.scrollY;

  images.forEach((img) => {
    let speed = img.getAttribute("data-speed");
    img.style.transform = `translateY(${scrollY * speed}px)`;
  });
});

// Related Product Carousel
document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function () {
    const carousel = document.querySelector('.related-products-carousel');

    if (
      carousel &&
      typeof jQuery !== 'undefined' &&
      !carousel.classList.contains('owl-loaded')
    ) {
      const $carousel = jQuery(carousel);

      $carousel.owlCarousel({
        loop: true,
        margin: 16,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3500,
        autoplayHoverPause: true,
        responsive: {
          0: { items: 1 },
          600: { items: 2 },
          1000: { items: 3 },
        },
        // navText: [
        //   '<img src="https://cdn.shopify.com/s/files/1/0785/2743/0939/files/Previous_Arrow_Button.png?v=1775024027" />',
        //   '<img src="https://cdn.shopify.com/s/files/1/0785/2743/0939/files/Next_Arrow_Button.png?v=1775024027" />'
        // ],
        onInitialized: function () {
          const $nav = $carousel.find('.owl-nav');

          // Wrap both buttons inside a div
          if (!$nav.find('.custom-nav').length) {
            $nav.wrapInner('<div class="slider-buttons custom-nav"></div>');
          }
        }
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});